<template>
  <div>
    <YoutubeVideo v-if="isYoutube" :videoId="video.videoId" />
    <VimeoVideo v-else-if="isVimeo" :videoId="video.videoId" />
  </div>
</template>

<script>
import YoutubeVideo from "./YoutubeVideo";
import VimeoVideo from "./VimeoVideo";

export default {
  name: "VideoGridItem",
  props: {
    video: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    YoutubeVideo,
    VimeoVideo,
  },
  computed: {
    isYoutube() {
      return this.video.source === "youtube";
    },
    isVimeo() {
      return this.video.source === "vimeo";
    },
  },
};
</script>
<style scoped>
.category {
  margin-bottom: 24px;
}
.category-name {
  font-size: 16px;
  font-weight: bold;
  text-align: left;
  margin-bottom: 12px;
}
</style>
